'use client'

import React from 'react'

import {
  Breadcrumbs,
  Footer,
  Header,
  Main,
  PageWrapper,
} from 'Components/Blocks'
import { ContactHeroSection } from 'Components/Sections'
import { ContactAltPageData } from 'Data/types'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'
import { CONTACT } from 'Constants/Paths'

type Props = {
  data?: ContactAltPageData
}

function ContactPage({ data }: Props) {
  return (
    <PageWrapper>
      <Header />

      <Main>
        <Breadcrumbs
          paths={[{ caption: 'Contact', href: CONTACT }]}
          pt={160}
          px={LANDING_INLINE_PADDINGS}
        />

        <ContactHeroSection data={data?.contactAltPage} pb={17} pt={9} />
      </Main>

      <Footer />
    </PageWrapper>
  )
}

export default ContactPage
